<template>
  <el-card>
    <page-main
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :layouts="[
          'Total',
          'Sizes',
          'PrevJump',
          'PrevPage',
          'NextPage',
          'NextJump',
          'FullJump',
        ]"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="600px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <metadata-edit-form
        ref="editForm"
        :code="editFormDialogOptions.code"
        :metadataCode="editFormDialogOptions.metadataCode"
        :disabled="editFormDialogOptions.disabled"
        :useless="editFormDialogOptions.useless"
        :params="editFormDialogOptions.params"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ $l("INDEX.btn_save") || "保存" }}</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import PageMain from "./main"
import PageHeader from "./header"
import BaseTable from "@/mixins/base-table"
import MetadataEditForm from "../metadata-edit-form"
import store from "../../store"
export default {
  components: {
    PageHeader,
    PageMain,
    MetadataEditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: "",
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .materialmaterialMetadataListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          store.commit("setSelected", this.tableData[0])
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit: this.$l("form_label_material_edit") || "编辑物料属性字典信息",
        add: this.$l("form_label_material_add") || "添加物料属性字典信息",
        detail: this.$l("form_label_material_details") || "物料属性字典详情",
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.metadataCode,
        disabled: type === "detail",
        useless: type === "edit",

        //metadataCode: this.selected.metadataCode,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
